import React, { useState } from 'react';
import { List, Steps } from 'antd';
import Icon from '../../../icon/Icon';
import { type IOffer } from '../../../../store/slices/offersSlice';
import { type Unit } from '../../../../store/slices/unitsSlice';
import renderOfferStatus from '../../../../functions/agent/offers/renderOfferStatus';
import { type TimelineItem } from '../viewingTimelines/ViewingTimeline';
import StepComponent from './StepComponent';
import { textsOfferTimelineSale } from '../../../texts/timelinesTexts';
interface IProps {
    offer: IOffer
    unit: Unit

}

const allStatuses = ['Client docs required', 'Resubmit required',
    'Confirmed',
    'Waiting for slip approval',
    'Slip approved', 'Slip rejected',
    'Signing F form',
    'Signing other documents',
    'Obtaining NOC',
    'Downpayment',
    'Transfer process',
    'Waiting for updates',
    'Waiting booking form send',
    'Waiting booking form sign',
    'F Form requested',
    'Manual contract requested',
    'Waiting draft contract send',
    'Waiting draft contract approve',
    'Draft contract approved',
    'F Form sent',
    'Manual contract sent',
    'F Form signed',
    'Manual contract signed',
    'In-process',
    "Sent to landlord",
    "Approved",
    'Negotiated by other agent', 'Negotiated by agent',
    'Negotiated by BSO',
    'Negotiated by landlord',
    'Pending BSO admin confirmation', 'Completed', 'Rejected', 'Canceled', 'Canceled by BSO', 'Canceled by yourself', 'Canceled by agent', 'Canceled by other agent'
]

export default function GroupTimelineSale({ offer, unit }: IProps): JSX.Element {
    let process = 0
    const offerStatuses = [renderOfferStatus(offer?.attributes?.Statuses[0], offer.id)]



    if (offerStatuses?.includes('Client docs required')) {
        process = 0
    } if (offerStatuses?.includes('Resubmit required')) {
        process = 0
        textsOfferTimelineSale.stepClientData = 'Resubmit and wait sent offer.'
        textsOfferTimelineSale.descriptionStepClientData = 'Our specialist will be sent your offer soon after you resubmit.'
    }

    const groupDocumentation: TimelineItem[] = [
        {
            title: <StepComponent
                title={textsOfferTimelineSale.stepClientData}
                description={textsOfferTimelineSale.descriptionStepClientData}
                process={0}
                currentProcess={process}
                statuses={offerStatuses}
                rejectReason={process === 0 ? offer?.attributes?.RejectReason ?? undefined : undefined}
            />,
            status: process === 0 && (offerStatuses?.[0]?.includes('Canceled') || offerStatuses?.includes('Rejected')) ? 'finish' : undefined,
            // description: (<span className='fs-7'>{textsOfferTimelineSale.descriptionStepClientData}</span>)
        }
    ]





    if (offerStatuses?.includes('In-process')) {
        process = 0
    } if (offerStatuses?.includes("Sent to landlord") || offerStatuses?.includes("Approved")) {
        process = 1
    }

    const groupUnderReview: TimelineItem[] = [
        {
            title: <StepComponent
                title={textsOfferTimelineSale.stepInProcess}
                process={0}
                currentProcess={process}
                statuses={offerStatuses}
                rejectReason={process === 0 ? offer?.attributes?.RejectReason ?? undefined : undefined}
            />,
            //  description: (<span className='fs-7'>{textsOfferTimelineSale.descriptionInProcess}</span>)
        },
        {
            title: <StepComponent
                title={textsOfferTimelineSale.stepApprovedOrRejected}
                description={textsOfferTimelineSale.descriptionApprovedOrRejected}
                process={1}
                currentProcess={process}
                statuses={offerStatuses}
            />,
            //  description: textsOfferTimelineSale.descriptionApprovedOrRejected
        }
    ]



    if (offerStatuses?.includes('Confirmed')) {
        process = 0
        textsOfferTimelineSale.stepConfirmed = 'Landlord confirmed offer.'
        textsOfferTimelineSale.addTitle = '.'
        textsOfferTimelineSale.descriptionConfirmed = 'Send email and phone client.'
    } else if (offerStatuses?.includes('Negotiated by agent') || offerStatuses?.includes('Negotiated by yourself')) {
        process = 0
        textsOfferTimelineSale.stepConfirmed = 'You requested the offer negotiation'
        textsOfferTimelineSale.descriptionConfirmed = 'Please wait until our specialist or the landlord takes action about your negotiation of this offer'
    } else if (offerStatuses?.includes('Negotiated by BSO')) {
        process = 0
        textsOfferTimelineSale.stepConfirmed = 'The BSO offered another option from landlord'
        textsOfferTimelineSale.descriptionConfirmed = 'If you are satisfied, wait for a call from BSO, or provide updated offer details.'
    } else if (offerStatuses?.includes('Negotiated by landlord')) {
        process = 0
        textsOfferTimelineSale.stepConfirmed = 'The landlord offered another option'
        textsOfferTimelineSale.descriptionConfirmed = 'If you are satisfied, wait call from BSO, or provide updated offer details.'
    } else if (offerStatuses?.includes('Pending BSO admin confirmation')) {
        process = 1
        textsOfferTimelineSale.stepConfirmed = 'In the process of reviewing your consent.'
        textsOfferTimelineSale.descriptionConfirmed = 'Please wait until our specialist will be reviewing your consent.'
    } else if (offerStatuses?.includes('Waiting draft contract send')) {
        process = 1
    } else if (offerStatuses?.includes('Waiting draft contract approve')) {
        process = 2
    } else if (offerStatuses?.includes('Draft contract approved')) {
        process = 3
    } else if (offerStatuses?.includes('F Form requested') || offerStatuses?.includes('Manual contract requested')) {
        process = 4
    } else if (offerStatuses?.includes('F Form sent') || offerStatuses?.includes('Manual contract sent')) {
        process = 5
    } else if (offerStatuses?.includes('F Form signed') || offerStatuses?.includes('Manual contract signed')) {
        process = 6
    } else if (offerStatuses?.includes('Waiting for updates')) {
        process = 7
        textsOfferTimelineSale.descriptionDynamicStep = offer.attributes?.StatusUpdateDescription?.includes("UPLOAD-URGENT") ? "" : String(offer.attributes?.StatusUpdateDescription ?? '')
    } else if (!allStatuses?.includes(offerStatuses[0])) {
        process = 7
        textsOfferTimelineSale.dynamicStep = 'Current action: ' + offerStatuses[0];
        textsOfferTimelineSale.descriptionDynamicStep = offer.attributes?.StatusUpdateDescription?.includes("UPLOAD-URGENT") ? "" : String(offer.attributes?.StatusUpdateDescription ?? '')
    }

    const groupConfirmationAndFinalization: TimelineItem[] = [
        {
            title: <StepComponent
                title={textsOfferTimelineSale.stepConfirmed + '\n' + textsOfferTimelineSale.descriptionConfirmed}
                process={0}
                currentProcess={process}
                statuses={offerStatuses}
                negotiationReason={process === 0 ? offer?.attributes?.RejectReason ?? undefined : undefined}
            />,
            //   description: textsOfferTimelineSale.descriptionConfirmed
        },
        {
            title: <StepComponent
                title={textsOfferTimelineSale.stepContractDraftSending}
                description={textsOfferTimelineSale.descriptionStepContractDraftSending}
                process={1}
                currentProcess={process}
                statuses={offerStatuses}
                negotiationReason={process === 1 ? offer?.attributes?.RejectReason ?? undefined : undefined}
            />,
            //  description: textsOfferTimelineSale.descriptionStepContractDraftSending
        },
        {
            title: <StepComponent
                title={textsOfferTimelineSale.stepContractDraftConfirmed}
                description={textsOfferTimelineSale.descriptionStepContractDraftConfirmed}
                process={2}
                currentProcess={process}
                statuses={offerStatuses}
            />,
            // description: textsOfferTimelineSale.descriptionStepContractDraftConfirmed
        },
        {
            title: <StepComponent
                title={textsOfferTimelineSale.stepChooseContractType}
                description={textsOfferTimelineSale.descriptionStepChooseContractType}
                process={3}
                currentProcess={process}
                statuses={offerStatuses}
            />,
            // description: textsOfferTimelineSale.descriptionStepChooseContractType
        },
        {
            title: <StepComponent
                title={textsOfferTimelineSale.stepMOU + " " + textsOfferTimelineSale.descriptionStepMOU}
                description={textsOfferTimelineSale.descriptionStepMOU}
                process={4}
                currentProcess={process}
                statuses={offerStatuses}
            />,
            //  description: textsOfferTimelineSale.descriptionStepMOU
        },
        {
            title: <StepComponent
                title={textsOfferTimelineSale.stepMOU2}
                description={textsOfferTimelineSale.descriptionStepMOU2}
                process={5}
                currentProcess={process}
                statuses={offerStatuses}
            />,
            //  description: textsOfferTimelineSale.descriptionStepMOU2
        },
        {
            title: <StepComponent
                title={textsOfferTimelineSale.stepMOU3}
                description={textsOfferTimelineSale.descriptionStepMOU3}
                process={6}
                currentProcess={process}
                statuses={offerStatuses}
            />,
            //   description: textsOfferTimelineSale.descriptionStepMOU3
        },
        {
            title: <StepComponent
                title={textsOfferTimelineSale.dynamicStep}
                description={textsOfferTimelineSale.descriptionDynamicStep}
                process={7}
                currentProcess={process}
                statuses={offerStatuses}
            />,
            //  description: textsOfferTimelineSale.descriptionDynamicStep
        },

    ]




    if (offerStatuses?.includes('Canceled') || offerStatuses?.includes('Canceled by yourself') || offerStatuses?.includes('Canceled by agent')) {
        process = 0
        textsOfferTimelineSale.stepApprovedOrRejected = 'You have canceled Offer!'
    } else if (offerStatuses?.includes('Rejected')) {
        process = 0
        textsOfferTimelineSale.stepApprovedOrRejected = 'Your offer was rejected by BSO.'
        textsOfferTimelineSale.descriptionApprovedOrRejected = 'Unfortunately, our specialist has decided to reject your offer because of the reason stated above'
    } else if (offerStatuses?.includes('Completed')) {
        process = 0
        textsOfferTimelineSale.stepApprovedOrRejected = 'Deal closed successfully.'
    }
    const groupClosure: TimelineItem[] =
        [
            {
                title: <StepComponent
                    title={textsOfferTimelineSale.stepApprovedOrRejected}
                    process={0}
                    currentProcess={process}
                    statuses={offerStatuses}
                    rejectReason={process === 0 ? offer?.attributes?.RejectReason ?? undefined : undefined}
                />,
                status: 'finish',
            }
        ]

    const data = [
        ...(!(offerStatuses[0].includes("Canceled") || offerStatuses[0].includes("Rejected")) ? [
            {
                title: 'Documentation',
                status: undefined,
                current: 0,
                icon: <i className="ki-duotone ki-paper-clip fs-5x"></i>,
                iconProcess: <i className="ki-duotone ki-paper-clip fs-5x text-success"></i>,
                description: 'The stage where client documents are required or need resubmission.',
                statuses: ['Client docs required', 'Resubmit required'],
                items: groupDocumentation
            },
            {
                title: 'Under review',
                current: 1,
                status: undefined,
                icon: <i className="ki-duotone ki-loading fs-5x">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>,
                iconProcess: <i className="ki-duotone ki-loading fs-5x text-success">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>,
                description: 'The initial stage where terms are being discussed and adjusted, where the deal is being processed.',
                statuses: ['In-process',
                    "Sent to landlord",
                    "Approved",
                    'Negotiated by other agent', 'Negotiated by agent',
                    'Negotiated by BSO',
                    'Negotiated by landlord',
                    'Pending BSO admin confirmation'
                ],
                items: groupUnderReview
            },
            {
                title: 'Confirmations & Finalization',
                current: 2,
                status: undefined,
                icon: <i className="ki-duotone ki-scroll fs-5x">
                    <span className="path1"></span>
                    <span className="path2"></span>
                    <span className="path3"></span>
                </i>, iconProcess: <i className="ki-duotone ki-scroll fs-5x text-success">
                    <span className="path1"></span>
                    <span className="path2"></span>
                    <span className="path3"></span>
                </i>,
                description: 'This stage involves confirming the terms of the deal, agreeing on final conditions, and preparing for the next steps.The final steps before completion, including payment approvals, form submissions, and other formalities.',
                statuses: [
                    'Confirmed',
                    'Waiting for slip approval',
                    'Slip approved', 'Slip rejected',
                    'Signing F form',
                    'Signing other documents',
                    'Obtaining NOC',
                    'Downpayment',
                    'Transfer process',
                    'Waiting for updates',
                    'Waiting booking form send',
                    'Waiting booking form sign',
                    'F Form requested',
                    'Manual contract requested',
                    'Waiting draft contract send',
                    'Waiting draft contract approve',
                    'Draft contract approved',
                    'F Form sent',
                    'Manual contract sent',
                    'F Form signed',
                    'Manual contract signed'
                ],
                items: groupConfirmationAndFinalization
            }] : []),
        {
            title: 'Closure',
            status: undefined,
            icon: <i className="ki-duotone ki-check fs-5x"></i>,
            iconProcess: <i className="ki-duotone ki-check fs-5x text-success"></i>,
            description: 'The stage where the deal is closed either completed.',
            statuses: ['Completed', 'Rejected', 'Canceled', 'Canceled by BSO', 'Canceled by yourself', 'Canceled by agent', 'Canceled by other agent'],
            items: groupClosure
        },
    ];



    const [expanded, setExpanded] = useState(false);

    const activeStepIndex = data.findIndex(step =>
        step.statuses.includes(offerStatuses[0])
        ||
        (step.title === 'Conformations & Finalization' &&
            !(data[0].statuses.includes(offerStatuses[0]) ||
                data[1].statuses.includes(offerStatuses[0]) ||
                data[2].statuses.includes(offerStatuses[0]) ||
                data[3].statuses.includes(offerStatuses[0])))
    );

    const renderSteps = (items: any[], currentProcess: number): any => {
        const startIndex = Math.max(0, currentProcess - 1);
        const endIndex = Math.min(items.length, currentProcess + 2);
        const stepsToShow = expanded ? items : items.slice(startIndex, endIndex);
        return stepsToShow.map((item: any, idx: number) => {
            const realIndex = expanded ? idx : startIndex + idx;
            let status: string;
            if (realIndex < currentProcess) {
                status = "finish";
            } else if (realIndex === currentProcess) {
                status = stepsToShow.length === 1 ? "finish" : "process";
            } else {
                status = "wait";
            }
            return {
                ...item,
                status,
            };
        });
    };


    return (
        <div className='my-4 pt-2' style={{ maxWidth: '450px', width: '100%' }}>
            <List
                itemLayout="horizontal"
                dataSource={data}
                renderItem={(group, index) => {
                    const isActive = index === activeStepIndex;
                    const currentProcess = process;
                    return (
                        <div className='d-flex flex-column'>
                            <List.Item >
                                <div className='d-flex flex-column w-100'>
                                    <List.Item.Meta
                                        style={{
                                            lineHeight: 0.1
                                        }}
                                        avatar={




                                            <div className={`d-flex align-items-center justify-content-center w-100`}>
                                                {isActive ?
                                                    offerStatuses[0].includes("Completed") ?
                                                        <span className={'border border-2 align-middle p-7 position-relative border-success  rounded rounded-circle'}>
                                                        </span> : offerStatuses[0].includes("Canceled") || offerStatuses[0].includes("Rejected") ?
                                                            <span className={'border border-2 align-middle p-7 position-relative border-danger  rounded rounded-circle'}>
                                                            </span> :
                                                            < span className={'spinner-border spinner-border-sm align-middle p-7 position-relative text-success'}>
                                                            </span>
                                                    : null}
                                                <span className={`position-${isActive ? 'absolute' : 'static'}`}>
                                                    {isActive ? offerStatuses[0].includes("Canceled") || offerStatuses[0].includes("Rejected") ? <i className="ki-duotone ki-cross-circle fs-5x text-danger">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i> : group.iconProcess : group.icon}
                                                </span>
                                            </div>
                                            // <div className={`d-flex align-items-center justify-content-center w-100`}>
                                            //     {isActive ? (
                                            //         <span className={'spinner-border spinner-border-sm align-middle p-7 position-relative text-success'}>
                                            //         </span>
                                            //     ) : null}
                                            //     <span className={`position-${isActive ? 'absolute' : 'static'}`}>
                                            //         {isActive ? group.iconProcess : group.icon}
                                            //     </span>
                                            // </div>
                                        }
                                        title={<div className='lh-1'><span className='lh-1 fs-4'>{group.title.toUpperCase()}</span></div>}
                                        description={<div className='lh-1'><span className='lh-1 fs-7'>{group.description}</span></div>}
                                    />
                                    <div className='ps-4 ms-4 mt-2'>
                                        {isActive &&
                                            <>
                                                <Steps
                                                    className='w-100'
                                                    style={{ marginTop: 8, width: '100%' }}
                                                    current={currentProcess}
                                                    status={undefined}
                                                    // items={group.items.map((item, idx) => ({
                                                    //     ...item,
                                                    //     status: idx < currentProcess ? "finish" : idx === currentProcess ? "process" : "wait"
                                                    // }))}
                                                    items={renderSteps(group.items, currentProcess)}
                                                />
                                                {group.items.length > 3 &&
                                                    <div className={'text-end mt-2'}>
                                                        <div className={'btn btn-light-secondary py-2 text-end text-dark  px-7'}>
                                                            <div className="d-flex justify-content-around align-items-center w-30"
                                                                onClick={() => { setExpanded(!expanded); }}>
                                                                <Icon name={expanded ? 'play_circle' : 'expand_circle_up'} className={'fs-5'} />
                                                                <span className="ms-1 fs-8">{expanded ? 'Hide' : 'Show all'}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </>
                                        }
                                    </div>
                                </div>
                            </List.Item>
                        </div>
                    )
                }}
            />
        </div>
    );
}